export class ListSaasEntitiesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSaasEntitiesRequestFilters",
            "format": ""
        },
        {
            "name": "sort",
            "baseName": "sort",
            "type": "ListSaasEntitiesSort",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
